import { render, staticRenderFns } from "./pendingValidationOrder.vue?vue&type=template&id=7f127ef2&"
import script from "./pendingValidationOrder.vue?vue&type=script&lang=js&"
export * from "./pendingValidationOrder.vue?vue&type=script&lang=js&"
import style0 from "./pendingValidationOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports